import { denormalisedResponseEntities, ensureOwnListing, getFormatedDisplayName } from '../util/data';
import { isTransactionInitiateAmountTooLowError, storableError } from '../util/errors';
import { transitionsToRequested } from '../util/transaction';
import { LISTING_STATE_DRAFT } from '../util/types';
import * as log from '../util/log';
import { authInfo } from './Auth.duck';
import parser from 'simple-xml-to-json';
import { stripeAccountCreateSuccess } from './stripeConnectAccount.duck';

import { updateProfile } from '../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import axios from 'axios'
import {
  getTransactions,
  getTransactionsError,
  getTransactionsInProgress,
} from './Transactions.duck';
import {
  emailInviteError, emailInviteRequest,
  emailInviteSuccess,
} from '../containers/ReferralSystemPage/ReferralSystemPage.duck';

import { util as sdkUtil } from '../util/sdkLoader';

async function makeRequest(method, url, data) {
  const options = {
    baseURL: process.env.REACT_APP_RAILS_API_URL,
    method: method,
    url: url,
    data,
  };

  let res = await axios(options);
  try {
    return res;
  } catch (e) {
    return new Error(e);
  }
}

// ================ Action types ================ //

export const CURRENT_USER_SHOW_REQUEST = 'app/user/CURRENT_USER_SHOW_REQUEST';
export const CURRENT_USER_SHOW_SUCCESS = 'app/user/CURRENT_USER_SHOW_SUCCESS';
export const CURRENT_USER_SHOW_ERROR = 'app/user/CURRENT_USER_SHOW_ERROR';

export const CLEAR_CURRENT_USER = 'app/user/CLEAR_CURRENT_USER';

export const BONUS_UPDATE_REQUEST = 'app/user/BONUS_UPDATE_REQUEST';

export const FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST =
  'app/user/FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST';
export const FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS =
  'app/user/FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS';
export const FETCH_CURRENT_USER_HAS_LISTINGS_ERROR =
  'app/user/FETCH_CURRENT_USER_HAS_LISTINGS_ERROR';

export const FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST';
export const FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS';
export const FETCH_CURRENT_USER_NOTIFICATIONS_ERROR =
  'app/user/FETCH_CURRENT_USER_NOTIFICATIONS_ERROR';

export const FETCH_CURRENT_USER_HAS_ORDERS_REQUEST =
  'app/user/FETCH_CURRENT_USER_HAS_ORDERS_REQUEST';
export const FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS =
  'app/user/FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS';
export const FETCH_CURRENT_USER_HAS_ORDERS_ERROR = 'app/user/FETCH_CURRENT_USER_HAS_ORDERS_ERROR';

export const SEND_VERIFICATION_EMAIL_REQUEST = 'app/user/SEND_VERIFICATION_EMAIL_REQUEST';
export const SEND_VERIFICATION_EMAIL_SUCCESS = 'app/user/SEND_VERIFICATION_EMAIL_SUCCESS';
export const SEND_VERIFICATION_EMAIL_ERROR = 'app/user/SEND_VERIFICATION_EMAIL_ERROR';

// ================ Reducer ================ //

const mergeCurrentUser = (oldCurrentUser, newCurrentUser) => {
  const { id: oId, type: oType, attributes: oAttr, ...oldRelationships } = oldCurrentUser || {};
  const { id, type, attributes, ...relationships } = newCurrentUser || {};

  // Passing null will remove currentUser entity.
  // Only relationships are merged.
  // TODO figure out if sparse fields handling needs a better handling.
  return newCurrentUser === null
    ? null
    : oldCurrentUser === null
    ? newCurrentUser
    : { id, type, attributes, ...oldRelationships, ...relationships };
};

const API_URL = process.env.REACT_APP_API_URL;
const RAILS_API_URL = process.env.REACT_APP_RAILS_API_URL;

const initialState = {
  currentUser: null,
  bonus: 0,
  currentUserShowError: null,
  currentUserHasListings: false,
  currentUserHasListingsError: null,
  currentUserNotificationCount: 0,
  currentUserNotificationCountError: null,
  currentUserHasOrders: null, // This is not fetched unless unverified emails exist
  currentUserHasOrdersError: null,
  sendVerificationEmailInProgress: false,
  sendVerificationEmailError: null,
  currentUserListing: null,
  currentUserListingFetched: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case CURRENT_USER_SHOW_REQUEST:
      return { ...state, currentUserShowError: null };
    case CURRENT_USER_SHOW_SUCCESS:
      return { ...state, currentUser: mergeCurrentUser(state.currentUser, payload) };
    case CURRENT_USER_SHOW_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, currentUserShowError: payload };

    case CLEAR_CURRENT_USER:
      return {
        ...state,
        currentUser: null,
        currentUserShowError: null,
        currentUserHasListings: false,
        currentUserHasListingsError: null,
        currentUserNotificationCount: 0,
        currentUserNotificationCountError: null,
        currentUserListing: null,
        currentUserListingFetched: false,
      };

    case BONUS_UPDATE_REQUEST:
      return { ...state, bonus: payload };

    case FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST:
      return { ...state, currentUserHasListingsError: null };
    case FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS:
      return {
        ...state,
        currentUserHasListings: payload.hasListings,
        currentUserListing: payload.listing,
        currentUserListingFetched: true,
      };
    case FETCH_CURRENT_USER_HAS_LISTINGS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, currentUserHasListingsError: payload };

    case FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST:
      return { ...state, currentUserNotificationCountError: null };
    case FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS:
      return { ...state, currentUserNotificationCount: payload.transactions.length };
    case FETCH_CURRENT_USER_NOTIFICATIONS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, currentUserNotificationCountError: payload };

    case FETCH_CURRENT_USER_HAS_ORDERS_REQUEST:
      return { ...state, currentUserHasOrdersError: null };
    case FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS:
      return { ...state, currentUserHasOrders: payload.hasOrders };
    case FETCH_CURRENT_USER_HAS_ORDERS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, currentUserHasOrdersError: payload };

    case SEND_VERIFICATION_EMAIL_REQUEST:
      return {
        ...state,
        sendVerificationEmailInProgress: true,
        sendVerificationEmailError: null,
      };
    case SEND_VERIFICATION_EMAIL_SUCCESS:
      return {
        ...state,
        sendVerificationEmailInProgress: false,
      };
    case SEND_VERIFICATION_EMAIL_ERROR:
      return {
        ...state,
        sendVerificationEmailInProgress: false,
        sendVerificationEmailError: payload,
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const hasCurrentUserErrors = state => {
  const { user } = state;
  return (
    user.currentUserShowError ||
    user.currentUserHasListingsError ||
    user.currentUserNotificationCountError ||
    user.currentUserHasOrdersError
  );
};

export const verificationSendingInProgress = state => {
  return state.user.sendVerificationEmailInProgress;
};

// ================ Action creators ================ //

export const currentUserShowRequest = () => ({ type: CURRENT_USER_SHOW_REQUEST });

export const currentUserShowSuccess = user => ({
  type: CURRENT_USER_SHOW_SUCCESS,
  payload: user,
});

export const currentUserShowError = e => ({
  type: CURRENT_USER_SHOW_ERROR,
  payload: e,
  error: true,
});

export const clearCurrentUser = () => ({ type: CLEAR_CURRENT_USER });

const fetchCurrentUserHasListingsRequest = () => ({
  type: FETCH_CURRENT_USER_HAS_LISTINGS_REQUEST,
});

export const fetchCurrentUserHasListingsSuccess = (hasListings, listing) => ({
  type: FETCH_CURRENT_USER_HAS_LISTINGS_SUCCESS,
  payload: { hasListings, listing },
});

const fetchCurrentUserHasListingsError = e => ({
  type: FETCH_CURRENT_USER_HAS_LISTINGS_ERROR,
  error: true,
  payload: e,
});

const fetchCurrentUserNotificationsRequest = () => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_REQUEST,
});

export const fetchCurrentUserNotificationsSuccess = transactions => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_SUCCESS,
  payload: { transactions },
});

export const updateBonus = bonus => ({
  type: BONUS_UPDATE_REQUEST,
  payload: bonus
});

const fetchCurrentUserNotificationsError = e => ({
  type: FETCH_CURRENT_USER_NOTIFICATIONS_ERROR,
  error: true,
  payload: e,
});

const fetchCurrentUserHasOrdersRequest = () => ({
  type: FETCH_CURRENT_USER_HAS_ORDERS_REQUEST,
});

export const fetchCurrentUserHasOrdersSuccess = hasOrders => ({
  type: FETCH_CURRENT_USER_HAS_ORDERS_SUCCESS,
  payload: { hasOrders },
});

const fetchCurrentUserHasOrdersError = e => ({
  type: FETCH_CURRENT_USER_HAS_ORDERS_ERROR,
  error: true,
  payload: e,
});

export const sendVerificationEmailRequest = () => ({
  type: SEND_VERIFICATION_EMAIL_REQUEST,
});

export const sendVerificationEmailSuccess = () => ({
  type: SEND_VERIFICATION_EMAIL_SUCCESS,
});

export const sendVerificationEmailError = e => ({
  type: SEND_VERIFICATION_EMAIL_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const fetchCurrentUserHasListings = () => (dispatch, getState, sdk) => {
  dispatch(fetchCurrentUserHasListingsRequest());
  const { currentUser } = getState().user;

  if (!currentUser) {
    dispatch(fetchCurrentUserHasListingsSuccess(false));
    return Promise.resolve(null);
  }

  const params = {
    // Since we are only interested in if the user has
    // listings, we only need at most one result.
    page: 1,
    per_page: 1,
  };

  return sdk.ownListings
    .query(params)
    .then(response => {
      const hasListings = response.data.data && response.data.data.length > 0;
      const listing = hasListings ? response.data.data[0] : null;

      const hasPublishedListings =
        hasListings &&
        ensureOwnListing(response.data.data[0]).attributes.state !== LISTING_STATE_DRAFT;
      dispatch(fetchCurrentUserHasListingsSuccess(!!hasPublishedListings, listing));
    })
    .catch(e => dispatch(fetchCurrentUserHasListingsError(storableError(e))));
};

export const fetchCurrentUserHasOrders = () => (dispatch, getState, sdk) => {
  dispatch(fetchCurrentUserHasOrdersRequest());

  if (!getState().user.currentUser) {
    dispatch(fetchCurrentUserHasOrdersSuccess(false));
    return Promise.resolve(null);
  }

  const params = {
    only: 'order',
    page: 1,
    per_page: 1,
  };

  return sdk.transactions
    .query(params)
    .then(response => {
      const hasOrders = response.data.data && response.data.data.length > 0;
      dispatch(fetchCurrentUserHasOrdersSuccess(!!hasOrders));
    })
    .catch(e => dispatch(fetchCurrentUserHasOrdersError(storableError(e))));
};

// Notificaiton page size is max (100 items on page)
const NOTIFICATION_PAGE_SIZE = 100;

export const fetchCurrentUserNotifications = () => (dispatch, getState, sdk) => {
  dispatch(fetchCurrentUserNotificationsRequest());

  const apiQueryParams = {
    only: 'sale',
    last_transitions: transitionsToRequested,
    page: 1,
    per_page: NOTIFICATION_PAGE_SIZE,
  };

  sdk.transactions
    .query(apiQueryParams)
    .then(response => {
      const transactions = response.data.data;
      dispatch(fetchCurrentUserNotificationsSuccess(transactions));
    })
    .catch(e => dispatch(fetchCurrentUserNotificationsError(storableError(e))));
};

export const fetchCurrentUser = (params = null) => (dispatch, getState, sdk) => {
  dispatch(currentUserShowRequest());
  const { isAuthenticated } = getState().Auth;

  if (!isAuthenticated) {
    // Make sure current user is null
    dispatch(currentUserShowSuccess(null));
    return Promise.resolve({});
  }

  const parameters = params || {
    include: ['profileImage', 'stripeAccount'],
    'fields.image': [
      'variants.square-small',
      'variants.square-small2x',
      'variants.square-xsmall',
      'variants.square-xsmall2x',
    ],
    'imageVariant.square-xsmall': sdkUtil.objectQueryString({
      w: 40,
      h: 40,
      fit: 'crop',
    }),
    'imageVariant.square-xsmall2x': sdkUtil.objectQueryString({
      w: 80,
      h: 80,
      fit: 'crop',
    }),
  };

  return sdk.currentUser
    .show(parameters)
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the sdk.currentUser.show response');
      }
      const currentUser = entities[0];

      // Save stripeAccount to store.stripe.stripeAccount if it exists
      if (currentUser.stripeAccount) {
        dispatch(stripeAccountCreateSuccess(currentUser.stripeAccount));
      }

      // set current user id to the logger
      log.setUserId(currentUser.id.uuid);
      dispatch(currentUserShowSuccess(currentUser));
      return currentUser;
    })
    .then(currentUser => {
      dispatch(fetchCurrentUserHasListings());
      dispatch(fetchCurrentUserNotifications());
      if (!currentUser.attributes.emailVerified) {
        dispatch(fetchCurrentUserHasOrders());
      }

      ////////////////////////////////////////
      const isTutor = currentUser &&
                      currentUser.attributes.profile.privateData.userType && 
                      (currentUser.attributes.profile.privateData.userType).toLowerCase() === 'tutor';
      
      const hasUserAccount = currentUser &&
                            !!currentUser.attributes.profile.privateData.hasEntryAccount;
      if (isTutor && !hasUserAccount){
        dispatch(createUserEntry())
      }
      ///////////////////////////////////////

      // Make sure auth info is up to date
      dispatch(authInfo());
      return currentUser;
    })
    .catch(e => {
      // Make sure auth info is up to date
      dispatch(authInfo());
      log.error(e, 'fetch-current-user-failed');
      dispatch(currentUserShowError(storableError(e)));
    });
};

export const sendVerificationEmail = () => (dispatch, getState, sdk) => {
  if (verificationSendingInProgress(getState())) {
    return Promise.reject(new Error('Verification email sending already in progress'));
  }
  dispatch(sendVerificationEmailRequest());
  return sdk.currentUser
    .sendVerificationEmail()
    .then(() => dispatch(sendVerificationEmailSuccess()))
    .catch(e => dispatch(sendVerificationEmailError(storableError(e))));
};

export const encryptBonus = (bonus, rbl) => {
  return (dispatch) => {
    const url = `${API_URL}/api/encrypt?encryptBonus=${bonus}`;
    dispatch(updateBonus(bonus));

    return axios.get(url)
      .then(response => {
        dispatch(updateProfile({privateData: { bonus: response.data, rbl }}));
        return response.data;
      })
      .catch(e => console.log(storableError(e)));
  };
};

export const decryptBonus = (bonus) => {
  return (dispatch) => {
    const url = `${API_URL}/api/decrypt`;

    const body = { decryptBonus: bonus };

    return axios.post(url, body)
      .then(response => {
        dispatch(updateBonus(response.data || 0 ));
        return response.data;
      })
      .catch(e => console.log(storableError(e)))
  };
};

export const deductionBonus = (sum, userId) => {
  return () => {
    const url = `${API_URL}/api/deduction`;

    const body = { sum, userId };

    return axios.post(url, body)
      .then(response => {
        return response.data;
      })
      .catch(e => console.log(storableError(e)))
  };
};

export const refundBonus = (sum, userId) => {
  return () => {
    const url = `${API_URL}/api/refund-bonuses`;

    const body = { sum, userId };

    return axios.post(url, body)
      .then(response => {
        return response.data;
      })
      .catch(e => console.log(storableError(e)))
  };
};

export const updateReview = (params, id) => {
  return () => {
    const url = `${API_URL}/api/update-review`;
    const { reviewRating, reviewContent } = params;

    const body = { id, reviewRating, reviewContent };

    return axios.post(url, body)
      .then(response => {
        return response.data;
      })
      .catch(e => console.log(storableError(e)))
  };
};

export const createBBBRoom = (transaction, providerEmail) => (dispatch) => {
  const lesson = transaction.attributes.protectedData.lessonsOrder[0].split('_');
  const isAdditional = !!transaction.attributes.protectedData.parentTransactionId;

  if (isAdditional) {
    return Promise.resolve();
  }
  
  lesson.pop();
  const lessonName = lesson.join(' ');
  const start = new Date(transaction.booking.attributes.start)
  const data = {
    year: start.getUTCFullYear(),
    month: start.getUTCMonth() + 1,
    day: start.getUTCDate(),
    hours: start.getUTCHours(),
    minutes: start.getUTCMinutes(),
    seats: transaction.booking.attributes.seats,
    startTime: transaction.booking.attributes.start,
    duration: 1, // may be needed in the future
    provider_id: transaction.provider.id.uuid,
    providerEmail,
    customerEmail: transaction.attributes.protectedData.customerEmail,
    providerName: getFormatedDisplayName(transaction.provider),
    customerName: getFormatedDisplayName(transaction.customer),
    lesson: lessonName,
    transaction_id: transaction.id.uuid
  }

  return axios.post(`${RAILS_API_URL}/api/v1/users/meeting`, data)
    .then(res => {
      return res;
    })
    .catch(e => {
      console.log(e);
      return false
    });
}

export const changeBookingDate = (tx, bookingStart) => dispatch => {
  const start = new Date(bookingStart)
  const data = {
    year: start.getUTCFullYear(),
    month: start.getUTCMonth() + 1,
    day: start.getUTCDate(),
    hours: start.getUTCHours(),
    minutes: start.getUTCMinutes(),
    seats: tx.booking.attributes.seats,
    transaction_id: tx.id.uuid
  }

  makeRequest('post', '/api/v1/users/change_booking_date', data)
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log(e);
      return false
    });
}

export const notificationBackgroundCheck = data => async (dispatch)=> {
  return axios.post(`${RAILS_API_URL}/api/v1/users/notification_background_check`, data)
    .then(response => {
      if (response.status === 200) {
        return true;
      } else {
        throw new Error('response is not ok');
      }
    })
    .then(response => {
      dispatch(updateProfile({privateData: { sendBackgroundCheck: true }}))
    })
    .catch(e => {
      console.log(e);
      return false
    });
};

export const updateUserDebt = (value = null) => (dispatch, getState, sdk) => {
  const { isAuthenticated } = getState().Auth;
  if (!isAuthenticated) {
    dispatch(currentUserShowSuccess(null));
    return Promise.resolve({});
  }
  if(value || value == 0){
    return sdk.currentUser
    .updateProfile(
      { protectedData: { debt: value } },
      { expand: true }
    )
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
      }
      dispatch(fetchCurrentUserHasListings());
      dispatch(fetchCurrentUserNotifications());
      dispatch(authInfo());

      const currentUser = entities[0];
      log.setUserId(currentUser.id.uuid);
      dispatch(currentUserShowSuccess(currentUser));
      return currentUser;
    })
    .catch(e => {
      throw e;
    });
  }
};

export const createUserEntry = () => ( dispatch, getState, sdk ) => {
  const { currentUser } = getState().user;
  const flex_id = currentUser && currentUser.id.uuid;

  makeRequest('post', '/api/v1/users', {flex_id})
    .then(() => {
      return dispatch(createUserEntryCreated())
    })
    .catch(e => {
      console.log(e);
      return false
    });
}

export const createUserEntryCreated = () => ( dispatch, getState, sdk ) => {
  return (
    sdk
      .currentUser
      .updateProfile({
        privateData: {
            hasEntryAccount: true
          }
        }, {
          expand: true,
        })
        .then(() => dispatch(fetchCurrentUser()))
        .then(() => {
          const { currentUser } = getState().user;

          if (!currentUser) {
            return Promise.resolve(null);
          }

          const params = {
            page: 1,
            per_page: 1,
          };

          return sdk.ownListings
            .query(params)
            .then(response => {
              if (response.data.data && response.data.data[0]){
                const id = response.data.data[0].id.uuid;
                const { status } = response.data.data[0].attibutes || {};

                if (status === 'closed') {
                  return;
                }
                
                return sdk.ownListings.close({id}, {expand: true}).catch(e => {});
              }
            })
        })
        .catch(e => {})
  );
}

